var alignment_rtlignore_default = {
  "alignLeft": "EqPWZ",
  "textWrapNowrap": "QPN3n",
  "alignRight": "GNNhu",
  "alignCenter": "_84A8l",
  "sizeFullWidth": "W1mjf",
  "renderedInTable": "OwBrm",
  "sizeOriginal": "m5JTs",
  "sizeContent": "Ppurq",
  "sizeSmall": "ERc9Z",
  "sizeSmallCenter": "NbD4B",
  "flex": "Iy7BH",
  "LEFT": "cNTQh",
  "CENTER": "zqem1",
  "RIGHT": "rSDvw",
  "AUTO": "TWmWX",
  "JUSTIFY": "m49eE"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
